import React from 'react';
import DeploymentTrigger from './DeploymentTrigger';

const Deployments = () => {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-200">Production Deployments</h1>
      </div>

      <div className="bg-white dark:bg-slate-900 rounded-xl border border-gray-200 dark:border-slate-700 p-6">
        <DeploymentTrigger />
      </div>
    </div>
  );
};

export default Deployments;
